import { createFileRoute } from '@tanstack/react-router';
import { MarketingLayout } from '@/components/marketing/MarketingLayout';
import { Seo } from '@/components/marketing/Seo';

export const Route = createFileRoute('/privacy')({ component: PrivacyPage });

export function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" path="/privacy" screen="Privacy Screen">
      <p>
        Hmonglus uses account, learning-progress, subscription, and diagnostic data to provide and
        improve the service. We do not sell personal information.
      </p>
      <p>
        Payments are processed by Apple, Google, or Stripe. Hmonglus receives subscription status but
        does not store card details.
      </p>
      <p>You can request deletion from Settings. Contact support for privacy questions.</p>
    </LegalPage>
  );
}

export function LegalPage({
  title,
  path,
  screen,
  children,
}: React.PropsWithChildren<{ title: string; path: string; screen: string }>) {
  return (
    <MarketingLayout screen={screen}>
      <Seo title={`${title} — Hmonglus`} description={`${title} for the Hmonglus language-learning app.`} path={path} />
      <main className="bg-sky-light px-6 pb-24 pt-32">
        <article className="mx-auto max-w-3xl rounded-3xl bg-white p-8 shadow-sm">
          <h1 className="font-khula text-4xl font-light text-gray-900">{title}</h1>
          <div className="mt-6 space-y-5 leading-7 text-gray-600">{children}</div>
        </article>
      </main>
    </MarketingLayout>
  );
}
